import {useMutation, UseMutationOptions} from "@tanstack/react-query";
import {ResponseError} from "../../../models/common/Response";
import axios, {AxiosError} from "axios";

export type UseDeleteBucketImageDocTypeMappingParams = {
    image_doc_type: string;
    bucket_id: string;
};

export function useDeleteBucketImageDocTypeMapping(
    options?: UseMutationOptions<
        ResponseError,
        AxiosError<ResponseError>,
        UseDeleteBucketImageDocTypeMappingParams
    >
) {
    return useMutation({
        mutationFn: (params) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.delete('/v1/configuration/lis/bucket-image-doc-type-mapping', {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    image_doc_type: params?.image_doc_type,
                    bucket_id: params?.bucket_id
                },
            });
        },
        ...options,
    });
}